import * as Factory from 'factory.ts'
import faker from 'faker'

import { ContentTypeAppLabels, ContentTypeModels } from '@webapp/models/enums'
import { type ContentType } from '../../models'

export const ContentTypeMock = Factory.Sync.makeFactory<ContentType>({
  id: Factory.each(() => faker.random.number()),
  app_label: faker.random.arrayElement(Object.values(ContentTypeAppLabels)),
  model: faker.random.arrayElement(Object.values(ContentTypeModels)),
})
